import { defineMessages } from 'react-intl';
export default defineMessages({
  document: {
    defaultMessage: 'Document',
    id: `app.containers.WorkflowEditor.components.Rules.Condition.CommonSignStatus.document`,
  },
});
